import type { ComponentProps } from "react";
import { CiSearch } from "react-icons/ci";
import { IoCloseCircle } from "react-icons/io5";

import { cn } from "shared/utils/cn";

type Props = {
  inputClassName?: string;
  onCancel?: () => void;
};

export const SearchInput = ({
  className,
  inputClassName,
  onCancel,
  ...props
}: ComponentProps<"input"> & Props) => {
  const { value } = props;
  return (
    <div
      className={cn(
        "bg-oil relative flex h-9.5 w-full overflow-hidden rounded-xl focus-within:brightness-105",
        className
      )}
    >
      <input
        placeholder="Search"
        className={cn(
          "placeholder:text-pale-grey w-full py-2 pl-8 outline-hidden",
          inputClassName
        )}
        {...props}
      />
      <CiSearch className="text-pale-grey absolute top-1/2 left-2 size-5 -translate-y-1/2" />

      {value && (
        <button
          onClick={onCancel}
          className="text-pale-grey absolute top-1/2 right-0 flex -translate-y-1/2 cursor-pointer p-2 hover:brightness-110"
        >
          <IoCloseCircle className="size-5" />
        </button>
      )}
    </div>
  );
};
